// extracted by mini-css-extract-plugin
export var card = "_q6-0";
export var content = "_q6-2";
export var details = "_q6-3";
export var icon = "_q6-1";
export var iconBlue = "_q6-5";
export var iconBrand = "_q6-4";
export var iconGrayBlue = "_q6-6";
export var iconGreen = "_q6-7";
export var iconIndigo = "_q6-8";
export var iconOrange = "_q6-9";
export var iconPurple = "_q6-a";
export var iconRed = "_q6-b";
export var iconWarning = "_q6-c";